import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export type PurchaseGrant = {
  token: string;
  url: string;
  kind: 'pass' | 'subscription';
};

/**
 * Génère un lien/QR de don d'accès à usage unique (acheteur → enfant) via
 * l'edge fn create-purchase-grant. Sans argument, l'edge fn auto-résout l'accès
 * actif de l'appelant ; on peut cibler explicitement un pass/abonnement.
 */
export function useCreatePurchaseGrant() {
  return useMutation({
    mutationFn: async (target?: {
      access_right_id?: string;
      subscription_id?: string;
    }): Promise<PurchaseGrant> => {
      const { data, error } = await supabase.functions.invoke('create-purchase-grant', {
        body: target ?? {},
      });
      if (error) throw new Error(error.message);
      if (!data?.url) throw new Error('Réponse inattendue du serveur.');
      return data as PurchaseGrant;
    },
  });
}
